import React from 'react';
import './LoadingModal.css';
import { useLoading } from '../../constants/LoadingContext';
import CircularProgress from '@mui/material/CircularProgress';

function LoadingModal({ message = "로딩 중입니다..." }) {
    const { loading } = useLoading();

    //해외환자 확인  
    const userStr = sessionStorage.getItem("loginUser");
    const user = userStr ? JSON.parse(userStr) : null;
    const isOverseas = user?.usrSeCd === '17' || localStorage.getItem('isOverseasMode') === 'true';
    const displayMessage = isOverseas ? 'Loading...' : message;

    if (!loading) return null;
    
    return (
        <div className="loading-modal-backdrop">
            <div>
                {/* <div className="loading-spinner" /> */}
                <CircularProgress size="5rem"/>
                <div className="loading-message">{displayMessage}</div>
            </div>
        </div>
    );
}
export default LoadingModal;
